var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-card"},[_c('div',{staticClass:"cover"}),_c('div',{staticClass:"data"},[_c('div',{staticClass:"block big"}),_c('div',{staticClass:"block small"}),_c('div',{staticClass:"block small"}),_c('div',{staticClass:"block small",staticStyle:{"width":"60%"}}),_c('div',{staticClass:"block small",staticStyle:{"width":"40%"}})])])
}]

export { render, staticRenderFns }